import { useEffect, useRef, useState } from "react";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { loadPhoto, ShowLocaleDateTime } from "../../helpers/helpers";

import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/image-gallery.css';

export const PhotoGallery = ({images, startIndex, mch, onClose}) => {

    const [photos, setPhotos] = useState([]);
    const [isOpened, setIsOpened] = useState(true)
    const [index, setIndex] = useState(startIndex);    

    const [loading, setLoading] = useState(false);

    const controllerRef = useRef(null);
    const galleryRef = useRef(null);    

    useEffect(() => {   
        //галерея загружается - запрашиваем все фотографии     
        if (mch)
            loadPhotos()

        //загружается одна фотография
        else {
            setPhotos( images.map(val => {
                return {
                    id: val.id,
                    src: `data:image/png;base64, ${val.src}`,
                    original: `data:image/png;base64, ${val.src}`,
                    thumbnail: `data:image/png;base64, ${val.src}`,
                    originalClass: images.length > 1 ? "image-photos-gallery" : "image-photo-gallery",
                    thumbnailClass: "thumbnail-photo-gallery",
                    label: ShowLocaleDateTime(new Date(val.time)),                
                }
            }));
        }
    }, [])

    const loadPhotos = () => {
        setLoading(true);
        let photos = []
        const promises = images.map((photo) => {
            return loadPhoto({uuid: mch, photo_id: photo.id})
                .then((data) => {  
                    photos.push({
                            id: data.id,
                            src: `data:image/png;base64, ${data.file_source}`,
                            original: `data:image/png;base64, ${data.file_source}`,
                            thumbnail: `data:image/png;base64, ${data.file_source}`,
                            originalClass: "image-photos-gallery",
                            thumbnailClass: "thumbnail-photo-gallery",
                            label: ShowLocaleDateTime(new Date(data.time)),                                  
                    })                    
                })
        })
        Promise.allSettled(promises).then(() => {
            const sort = photos.sort((a, b) => b.id - a.id)
            setPhotos(sort)
            setLoading(false)
        })
    }

    const renderThumbnail = (item) => {
        return (
            <div className="thumb-photo-gallery-item">
                <img src={item.thumbnail}/>
                <div>{item.label}</div>
            </div>
        )
    }

    const onHandleClose = (e) => {
        setIsOpened(false);
        onClose();
    }    

    return (
        <div className="container-photo-gallery">
            {loading && 
                <div className="loading loading-wrapper"></div>
            }
            <span className="close close-big close-white" onClick={onHandleClose}>&times;</span>                
            <ImageGallery
            ref={galleryRef}
            items={photos}
            onSlide={(index) => setIndex(index)}
            disableThumbnailScroll={false}
            infinite={false}
            startIndex={startIndex}
            index={index}
            renderThumbInner={renderThumbnail}
            showThumbnails={photos.length > 1}
            showNav={photos.length > 1}
            showBullets={photos.length > 1}
            maxBullets={20}
            showPlayButton={false}
        />        
      </div>
    )

}